import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useVerifyMagicLink } from '../api/hooks.js';

export default function VerifyMagicLink() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const verify = useVerifyMagicLink();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    const token = params.get('token');
    if (!token) {
      setError('Missing token.');
      return;
    }
    ran.current = true;
    verify.mutateAsync(token)
      .then(() => navigate('/app/dashboard', { replace: true }))
      .catch(() => setError('That link is invalid or expired.'));
  }, [params, navigate, verify]);

  return (
    <div className="mx-auto mt-32 max-w-md px-6 text-center">
      {error ? (
        <>
          <h1 className="text-xl font-semibold text-slate-900">Couldn't sign in</h1>
          <p className="mt-2 text-sm text-slate-600">{error}</p>
          <Link to="/login" className="btn-primary mt-5 inline-block">
            Try again
          </Link>
        </>
      ) : (
        <p className="text-sm text-slate-500">Signing you in…</p>
      )}
    </div>
  );
}
